import { render, staticRenderFns } from "./GalapagosIslands.vue?vue&type=template&id=cd1cfc84&"
import script from "./GalapagosIslands.vue?vue&type=script&lang=js&"
export * from "./GalapagosIslands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports